import {simpleAction} from "../../utils";
import * as TYPES from "./types";

/**
 * Request Skus
 * @type {function(type: string): {type: string, payload: any}}
 */
export const skusGetRequest = simpleAction(TYPES.SKUS_GET_REQUEST);

/**
 * Request skus success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const skusGetSuccess = simpleAction(TYPES.SKUS_GET_SUCCESS);

/**
 * Request skus error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const skusGetError = simpleAction(TYPES.SKUS_GET_FAIL);

/**
 * Request items error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const skusGetDone = simpleAction(TYPES.SKUS_GET_DONE);

/**
 * Request Sku
 * @type {function(type: string): {type: string, payload: any}}
 */
export const skuLoadRequest = simpleAction(TYPES.SKU_LOAD_REQUEST);

/**
 * Request Sku success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const skuLoadSuccess = simpleAction(TYPES.SKU_LOAD_SUCCESS);

/**
 * Request Sku error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const skuLoadError = simpleAction(TYPES.SKU_LOAD_FAIL);

/**
 * Create Sku
 * @type {function(type: string): {type: string, payload: any}}
 */
export const skuCreateRequest = simpleAction(TYPES.SKU_CREATE_REQUEST);

/**
 * Create Sku Success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const skuCreateSuccess = simpleAction(TYPES.SKU_CREATE_SUCCESS);

/**
 * Create Sku Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const skuCreateError = simpleAction(TYPES.SKU_CREATE_FAIL);

/**
 * Create Sku Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const skuCreateDone = simpleAction(TYPES.SKU_CREATE_DONE);

/**
 * Update Sku
 * @type {function(type: string): {type: string, payload: any}}
 */
export const skuUpdateRequest = simpleAction(TYPES.SKU_UPDATE_REQUEST);

/**
 * Update Sku Success
 * @param payload
 * @type {function(type: string): {type: string, payload: any}}
 */
export const skuUpdateSuccess = simpleAction(TYPES.SKU_UPDATE_SUCCESS);

/**
 * Update Sku Error
 * @type {function(type: string): {type: string, payload: any}}
 */
export const skuUpdateError = simpleAction(TYPES.SKU_UPDATE_FAIL);

/**
 * Update Sku Done
 * @type {function(type: string): {type: string, payload: any}}
 */
export const skuUpdateDone = simpleAction(TYPES.SKU_UPDATE_DONE);
